// 網頁 ↔ Expo App（react-native-webview）橋接。非 App 環境全部 no-op。
// 協定見 docs/superpowers/specs/2026-10-07-pos-app-expo-design.md §4.3
export const NATIVE_EVENT = 'posapp';
export const BRIDGE_VERSION = 1;

export const isNativeApp = () =>
  typeof window !== 'undefined' && !!window.ReactNativeWebView;

let nativeAppState = 'active';
/** 原生告知的 App 狀態（active | background | inactive），供 AutoReload 判斷待機 */
export const setNativeAppState = (state) => {
  nativeAppState = typeof state === 'string' ? state : 'active';
};
export const getNativeAppState = () => nativeAppState;

/**
 * 網頁 → 原生。
 * @param {string} type  ready | route | logout | unread | beep | keepAwake | authRefreshed | scan | print
 * @param {object} [payload]
 * @returns {boolean} 是否真的送出
 */
export const postToNative = (type, payload = {}) => {
  if (!isNativeApp()) return false;
  try {
    window.ReactNativeWebView.postMessage(JSON.stringify({type, payload, v: BRIDGE_VERSION}));
    return true;
  } catch (error) {
    console.warn('postToNative 失敗:', error);
    return false;
  }
};

/**
 * 原生 → 網頁。原生用 injectJavaScript 執行
 *   window.dispatchEvent(new CustomEvent('posapp', {detail: {type, payload, v: 1}}))
 * @param {(msg: {type: string, payload: object, v: number}) => void} handler
 * @returns {() => void} 解除監聽
 */
let listenerCount = 0;

export const onNativeMessage = (handler) => {
  const listener = (event) => {
    const msg = event?.detail;
    if (!msg || typeof msg.type !== 'string') {
      console.warn('忽略格式不正確的原生訊息:', msg);
      return;
    }
    handler({type: msg.type, payload: msg.payload || {}, v: msg.v ?? BRIDGE_VERSION});
  };
  window.addEventListener(NATIVE_EVENT, listener);
  listenerCount += 1;
  window.__POSAPP_LISTENING__ = true; // 供原生存活探測判斷橋接監聽器已就緒
  let removed = false;
  return () => {
    if (removed) return;
    removed = true;
    window.removeEventListener(NATIVE_EVENT, listener);
    listenerCount -= 1;
    if (listenerCount <= 0) { listenerCount = 0; window.__POSAPP_LISTENING__ = false; }
  };
};

/** 測試與原生注入共用：對網頁派送一則原生訊息 */
export const dispatchNativeMessage = (msg) => {
  window.dispatchEvent(new CustomEvent(NATIVE_EVENT, {detail: msg}));
};
